module.exports = __webpack_public_path__ + "media/images/webpage/hotels/108/plan2-1-775334b8cb1c0d442edc47d8ace434ef.webp";